import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router"
import { AiFillCheckCircle, AiFillEye, AiOutlineClockCircle, AiOutlineCloseCircle } from "react-icons/ai"
import { RiLoader5Fill } from "react-icons/ri"
import { filterAvailableProgram, getAvailableJenjang, getProgram, register } from "./apis/Api";
import { handleAxiosNetworkError, handleResponse200 } from "../../utils/HttpUtils";
import { notifyError } from "../../utils/Notification";
import Select from "react-select"
import { MdRadioButtonUnchecked, MdOutlineCheckCircle } from "react-icons/md"
import { BiMailSend } from "react-icons/bi"
import { formatRupiah } from "../../utils/NumericHelper";
import { useSelector } from "react-redux";
import { isPhone } from "../../utils/PlatformHelper";
import TagManager from 'react-gtm-module'

const RegistrationPage = () => {

  const navigate = useNavigate()

  const { 
    systemProfile,
    screenSize
  } = useSelector(state => state.global)

  const [hashImage, setHashImage] = useState(Date.now());

  useEffect(() => {
    document.body.style.backgroundColor =  isPhone(screenSize.width) ? 'white' : '#232745';
  }, [screenSize.width])

  const [form, setForm] = useState({
    fullName: '',
    email: '',
    emailConfirmation: '',
    noHp: '',
    password: '',
    passwordConfirmation: '',
    passwordShown: false,
    passwordConfirmationShown: false
  });

  const [infoOpts, setInfoOpts] = useState({
    selectedOpt: null,
    data: [
      { label: 'Google', value: 'google' },
      { label: 'Facebook', value: 'facebook' },
      { label: 'Instagram', value: 'instagram' },
      { label: 'Email', value: 'email' },
      { label: 'Whatsapp', value: 'whatsapp' },
      { label: 'Lainnya', value: 'other' },
    ]
  })

  const [jenjangOpts, setJenjangOpts] = useState({
    selectedJenjang: null,
    data: []
  })

  const [fetchingJenjang, setFetchingJenjang] = useState(true)

  const [jenisPembiayaan, setJenisPembiayaan] = useState({
    selectedJenis: null,
    data: [
      { label: 'Reguler', value: 'reguler' },
      { label: 'Prestasi', value: 'beasiswa' }
    ]
  })

  const [programs, setPrograms] = useState([])

  const [fetchingPrograms, setFetchingPrograms] = useState(false)

  const [selectedProgram, setSelectedProgram] = useState(null)

  const [isProcessing, setIsProcessing] = useState(false)

  const [isSuccessRegistration, setIsSuccessRegistration] = useState(false)

  const [errors, setErrors] = useState([])

  useEffect(() => {
    if (window._PIXEL_ID) {
      window.fbq('track', 'AddToCart');
    }

    if (window._GTM_TAG) {
      const tagManagerArgs = {
        dataLayer: {
          event: 'pageView', // event to be picked up by GTM
        }
      }

      TagManager.dataLayer(tagManagerArgs);
    }
  }, [])

  useEffect(() => {
    getAvailableJenjang()
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            setJenjangOpts({ ...jenjangOpts, data: payload.map(i => ({ label: i.namaJenjangSekolah, value: i.idJenjangSekolah })) })
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
  }, [])

  useEffect(() => {

    if (!jenjangOpts.selectedJenjang || !jenisPembiayaan.selectedJenis) {
      return;
    }

    setFetchingPrograms(true)

    filterAvailableProgram(jenjangOpts.selectedJenjang.value, jenisPembiayaan.selectedJenis.value)
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            setPrograms(payload)
            setSelectedProgram(null)
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .finally(() => setFetchingPrograms(false))

  }, [jenjangOpts.selectedJenjang, jenisPembiayaan.selectedJenis])

  function onRegister() {
    const errors = []

    if (form.fullName === '') {
      errors.push('Nama lengkap tidak boleh kosong')
    }

    if (form.email === '') {
      errors.push('Email tidak boleh kosong')
    }

    // if (form.emailConfirmation === '') {
    //   errors.push('Email konfirmasi tidak boleh kosong')
    // }

    // if (form.email !== form.emailConfirmation) {
    //   errors.push('Email dan Email konfirmasi tidak sama')
    // }

    if (form.noHp === '') {
      errors.push('No Whatsapp tidak boleh kosong')
    } else {
      if (!form.noHp.startsWith('8')) {
        errors.push('No Whatsapp harus diawali angka 8 ')
      }
    }

    if (form.password === '') {
      errors.push('Password tidak boleh kosong')
    }
    // if (form.passwordConfirmation === '') {
    //   errors.push('Password konfirmasi tidak boleh kosong')
    // }

    // if (form.password !== form.passwordConfirmation) {
    //   errors.push('Password dan password konfirmasi tidak sama')
    // }

    if (errors.length > 0) {
      return alert(errors.reduce((acc, curr) => curr + ', ' + acc, ''))
    }

    setIsProcessing(true)

    const payload = {
      participantName: form.fullName,
      email: form.email,
      phone: form.noHp,
      password: form.password,
      source: infoOpts.selectedOpt.value,
      program: selectedProgram
    }

    register(payload)
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            setIsSuccessRegistration(true)

            if (window._PIXEL_ID) {
              window.fbq('track', 'CompleteRegistration');
            }

            if (window._GTM_TAG) {
              const gtmPayload = {
                namaLengkap: form.fullName,
                email: form.email,
                hp: form.noHp,
                sumberInformasi: infoOpts.selectedOpt.value
              }
              
              const tagManagerArgs = {
                dataLayer: {
                  event: 'registrationSuccess', // event to be picked up by GTM
                  payload: gtmPayload, // anything you want here
                }
              }

              TagManager.dataLayer(tagManagerArgs);
            }

          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => setIsProcessing(false))
    

    
  }

  if (!systemProfile) return null;

  return (
    <div
      className="h-screen"
    >
      <div
        className="py-10 flex justify-center"
      >

        <div
          className="relative rounded-sm flex"
          style={{
            width: isPhone(screenSize.width) ? '100%' : '800px',
            // height: isPhone(screenSize.width) ? '100%' : '800px'
          }}
        >
          {isProcessing && (
            <div 
              className="absolute top-0 left-0 right-0 bottom-0 z-10"
            />
          )}
          <div
            className="flex-1 bg-white "
          >

            {
              isSuccessRegistration ?
                (
                  <div
                    className="flex items-center w-full h-full"
                  >
                    <div
                      className="px-10 overflow-y-auto w-full flex items-center"
                      style={{
                        height: isPhone(screenSize.width) ? '100%' : '650px',
                        // marginTop: '-200px'
                      }}
                    >
                      <div
                        className="py-5 text-center space-y-8"
                        style={{
                          fontSize: '14px'
                        }}
                      >
                        <div
                          className="flex justify-center items-center space-x-3"
                        >
                          <AiFillCheckCircle className="h-20 w-20 text-green-500"/>
                          <BiMailSend className="h-20 w-20 text-green-500"/>
                        </div>
                        <div
                          className="space-y-3"
                        >
                          <div 
                            className="font-bold"
                            style={{
                              fontSize: '21px'
                            }}
                          >
                            Registrasi Akun Pendaftaran Berhasil!
                          </div>
                          <div
                            className={
                              isPhone(screenSize.width) ? '' : "px-16"
                            }
                          >
                            Kami telah mengirimkan email verifikasi. Cek inbox Email dan segera lakukan verifikasi.
                          </div>
                          <div className="space-y-1.5">
                            <button 
                              className="p-2 px-8 rounded-md border border-blue-500 hover:bg-blue-500 hover:text-white"
                              onClick={() => navigate("/login")}
                            >
                              Kembali
                            </button>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                )
                :
                (
                  <>
                    <div
                      className={
                        "pt-2 border-b flex justify-between " +
                        (isPhone(screenSize.width) ? ' px-5 ' : ' px-24 ')
                      }
                    >
                      <Link
                        to={'/login'}
                      >
                        <button
                          className="p-3 px-8 border-b-4 border-transparent font-bold"
                          style={{
                            fontSize: '14px'
                          }}
                        >
                          Masuk
                        </button>
                      </Link>
                      <Link
                        to={'/registration'}
                      >
                        <button
                          className="p-3 px-8 border-b-4 border-green-500 text-green-700 font-bold"
                          style={{
                            fontSize: '14px'
                          }}
                        >
                          Daftar
                        </button>
                      </Link>
                    </div>
                    <div
                      className="pt-5"
                    >
                      <div
                        className={
                          "py-5 overflow-y-auto " +
                          (isPhone(screenSize.width) ? '' : ' px-10 ')
                        }
                        style={{
                          minHeight: isPhone(screenSize.width) ? '100%' : '650px'
                        }}
                      >
                        <div
                          className="flex justify-center"
                        >
                          <div
                            className={
                              " space-y-5 " +
                              (isPhone(screenSize.width) ? 'px-10' : ' w-2/3 ')
                            }
                          >
                            <div
                            >
                              <div
                                className="text-center uppercase font-bold"
                              >
                                Formulir pendaftaran Akun PMB
                              </div>
                              <div
                                className="flex justify-center py-5"
                              >
                                <img src={systemProfile.companyLogo + '?' + hashImage} width={'250px'}/>
                              </div>
                            </div>
                            {errors.length > 0 && (
                              <div
                                className="py-5"
                              >
                                <div
                                  className="relative p-3 rounded-md bg-red-500 text-white"
                                >
                                  <div className="absolute right-2 top-1">
                                    <button
                                      onClick={() => setErrors([])}
                                    >
                                      <AiOutlineCloseCircle className="text-white h-5 w-5"/>
                                    </button>
                                  </div>
                                  <ol
                                    className="text-left"
                                    style={{
                                      fontSize: '14px'
                                    }}
                                  >
                                    {errors.map(err => (
                                      <li className="py-1 text-left">{err}</li>
                                    ))}
                                  </ol>
                                </div>
                              </div>
                            )}
                            <div
                              className="space-y-1"
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: '14px'
                                }}
                              >
                                <div>
                                  Nama Calon Siswa*
                                </div>
                                <div
                                  className="italic text-gray-500"
                                  style={{ fontSize: '12px' }}
                                >
                                  Nama lengkap calon siswa
                                </div>
                              </div>
                              <div
                                className="relative"
                              >
                                <input 
                                  className="w-full p-3 border border-gray-300 rounded-md outline-green-300"
                                  placeholder="Nama Lengkap"
                                  style={{
                                    fontSize: '14px'
                                  }}
                                  value={form.fullName}
                                  onChange={e => setForm({ ...form, fullName: e.target.value })}
                                />
                              </div>
                            </div>
                            <div
                              className="space-y-1"
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: '14px'
                                }}
                              >
                                <div>
                                  No. HP (Whatsapp)*
                                </div>
                                <div
                                  className="italic text-gray-500"
                                  style={{ fontSize: '12px' }}
                                >
                                  No Hp wali calon siswa
                                </div>
                              </div>
                              <div
                                className="relative"
                              >
                                <input 
                                  className="w-full p-3 pl-12 border border-gray-300 rounded-md outline-green-300"
                                  placeholder="(contoh: 8987654321)"
                                  style={{
                                    fontSize: '14px'
                                  }}
                                  value={form.noHp}
                                  onChange={e => setForm({ ...form, noHp: e.target.value })}
                                />
                                <div 
                                  class="flex absolute w-10 inset-y-0 left-0 items-center justify-center border-r border-gray-300"
                                  style={{
                                    fontSize: '14px'
                                  }}
                                >
                                  +62
                                </div>
                              </div>
                            </div>
                            
                            <div
                              className={
                                "grid gap-2 "+
                                (isPhone(screenSize.width) ? '' : '')
                              }
                            >
                              <div
                                className="space-y-1"
                              >
                                <div
                                  className=""
                                  style={{
                                    fontSize: '14px'
                                  }}
                                >
                                  <div>
                                    Email*
                                  </div>
                                  <div
                                    className="italic text-gray-500"
                                    style={{ fontSize: '12px' }}
                                  >
                                    Email akun pendaftar
                                  </div>
                                </div>
                                <div>
                                  <input 
                                    className="w-full p-3 border border-gray-300 rounded-md outline-green-300"
                                    placeholder="Email"
                                    style={{
                                      fontSize: '14px'
                                    }}
                                    value={form.email}
                                    onChange={e => setForm({ ...form, email: e.target.value })}
                                  />
                                </div>
                              </div>
                              {/* <div
                                className="space-y-1"
                              >
                                <div
                                  className=""
                                  style={{
                                    fontSize: '14px'
                                  }}
                                >
                                  <div>
                                    Konfirmasi Email*
                                  </div>
                                  <div
                                    className="italic text-gray-500"
                                    style={{ fontSize: '12px' }}
                                  >
                                    Konfirmasi ulang email
                                  </div>
                                </div>
                                <div>
                                  <input 
                                    className="w-full p-3 border border-gray-300 rounded-md outline-green-300"
                                    placeholder="Konfirmasi Email"
                                    style={{
                                      fontSize: '14px'
                                    }}
                                    value={form.emailConfirmation}
                                    onChange={e => setForm({ ...form, emailConfirmation: e.target.value })}
                                  />
                                </div>
                              </div> */}

                            </div>
                            <div
                              className={
                                "grid gap-2 "+
                                (isPhone(screenSize.width) ? '' : ' ')
                              }
                            >
                              <div
                                className="space-y-1"
                              >
                                <div
                                  className=""
                                  style={{
                                    fontSize: '14px'
                                  }}
                                >
                                  <div>
                                    Password*
                                  </div>
                                  <div
                                    className="italic text-gray-500"
                                    style={{ fontSize: '12px' }}
                                  >
                                    Password akun pendaftar
                                  </div>
                                </div>
                                <div
                                  className="relative"
                                >
                                  <input 
                                    type={form.passwordShown ? 'text' : 'password'}
                                    className="w-full p-3 pr-10 border border-gray-300 rounded-md outline-green-300"
                                    placeholder="Password"
                                    style={{
                                      fontSize: '14px'
                                    }}
                                    value={form.password}
                                    onChange={e => setForm({ ...form, password: e.target.value })}
                                  />
                                  <div class="flex absolute inset-y-0 right-3 items-center pl-3">
                                    <button
                                      onClick={() => setForm({ ...form, passwordShown: !form.passwordShown })}
                                    >
                                      <AiFillEye className="w-5 h-5"/>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              {/* <div
                                className="space-y-1"
                              >
                                <div
                                  className=""
                                  style={{
                                    fontSize: '14px'
                                  }}
                                >
                                  <div>
                                    Konfirmasi Password*
                                  </div>
                                  <div
                                    className="italic text-gray-500"
                                    style={{ fontSize: '12px' }}
                                  >
                                    Konfirmasi ulang password
                                  </div>
                                </div>
                                <div
                                  className="relative"
                                >
                                  <input 
                                    type={form.passwordConfirmationShown ? 'text' : 'password'}
                                    className="w-full p-3 pr-10 border border-gray-300 rounded-md outline-green-300"
                                    placeholder="Password"
                                    style={{
                                      fontSize: '14px'
                                    }}
                                    value={form.passwordConfirmation}
                                    onChange={e => setForm({ ...form, passwordConfirmation: e.target.value })}
                                  />
                                  <div class="flex absolute inset-y-0 right-3 items-center pl-3">
                                    <button
                                      onClick={() => setForm({ ...form, passwordConfirmationShown: !form.passwordConfirmationShown })}
                                    >
                                      <AiFillEye className="w-5 h-5"/>
                                    </button>
                                  </div>
                                </div>s
                              </div> */}

                            </div>
                            <div
                              className="space-y-1"
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: '14px'
                                }}
                              >
                                <div>
                                  Pilih jenjang sekolah*
                                </div>
                                <div
                                  className="italic text-gray-500"
                                  style={{ fontSize: '12px' }}
                                >
                                  pilih salah satu jenjang
                                </div>
                              </div>
                              <div
                                className="relative"
                              >
                                <Select
                                  value={jenjangOpts.selectedJenjang}
                                  options={jenjangOpts.data}
                                  menuPlacement="auto"
                                  className="w-full border border-gray-200 rounded-md outline-green-500"
                                  placeholder="Pilih salah satu jenjang"
                                  onChange={(value) => {
                                    setJenjangOpts({ ...jenjangOpts, selectedJenjang: value })
                                  }}
                                />
                              </div>
                            </div>
                            <div
                              className="space-y-1"
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: '14px'
                                }}
                              >
                                <div>
                                  Pilih jalur masuk*
                                </div>
                                <div
                                  className="italic text-gray-500"
                                  style={{ fontSize: '12px' }}
                                >
                                  pilih salah satu jalur masuk
                                </div>
                              </div>
                              <div
                                className="relative"
                              >
                                <Select
                                  value={jenisPembiayaan.selectedJenis}
                                  options={jenisPembiayaan.data}
                                  menuPlacement="auto"
                                  className="w-full border border-gray-200 rounded-md outline-green-500"
                                  placeholder="Pilih salah satu jenjang"
                                  onChange={(value) => {
                                    setJenisPembiayaan({ ...jenisPembiayaan, selectedJenis: value })
                                  }}
                                />
                              </div>
                            </div>
                            <div
                              className="space-y-1"
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: '14px'
                                }}
                              >
                                <div>
                                  Tahun daftar*
                                </div>
                                <div
                                  className="italic text-gray-500"
                                  style={{ fontSize: '12px' }}
                                >
                                  silahkan pilih salah satu program PMB yang tersedia
                                </div>
                              </div>
                              <div
                                className="space-y-3"
                              >
                                {
                                  fetchingPrograms ?
                                    <p>sedang mendapatkan data tahun daftar. mohon tunggu...</p>
                                    :
                                    programs.length == 0 && (jenjangOpts.selectedJenjang == null || jenisPembiayaan.selectedJenis == null) ?
                                      <p>Silahkan pilih dahulu jenjang dan jalur masuk</p>
                                      :
                                      programs.length == 0 ?
                                        <p>tidak ada tahun daftar tersedia untuk jenjang dan jalur masuk dipilih</p>
                                        :
                                        programs.map(p => (
                                          <button
                                            className={
                                              "w-full p-3 rounded border flex items-center space-x-5 " +
                                              (p.idProgram === selectedProgram ? " bg-green-500 border-green-500 text-white " : " hover:shadow-lg hover:border-green-500 ")
                                            }
                                            onClick={() => setSelectedProgram(p.idProgram)}
                                          >
                                            <div>
                                              { 
                                                p.idProgram === selectedProgram ?
                                                  (<MdOutlineCheckCircle className="h-5 w-5"/>)
                                                  :
                                                  (<MdRadioButtonUnchecked className="h-5 w-5"/>)
                                              }
                                            </div>
                                            <div
                                              className="space-y-1"
                                            >
                                              <div
                                                className="text-left font-bold"
                                                style={{
                                                  fontSize: '15px',
                                                  fontFamily: 'Nunito'
                                                }}
                                              >
                                                {p.namaProgram}
                                              </div>
                                              {systemProfile.companyProgramDetailVisibility && systemProfile.companyProgramDetailVisibility === 'program_detail_shown' && (
                                                <>
                                                <div
                                                  style={{
                                                    fontSize: '13px'
                                                  }}
                                                >
                                                  <div 
                                                    className={
                                                      "flex "+
                                                      (isPhone(screenSize.width) ? ' flex-col text-left py-1 ' : ' space-x-2 ')
                                                    }
                                                  >
                                                    <div className="w-32 text-left">Biaya pendaftaran</div>
                                                    {!isPhone(screenSize.width) && (<div>:</div>)}
                                                    <div>{formatRupiah(p.biayaPendaftaran)}</div>
                                                  </div>
                                                  <div 
                                                    className={
                                                      "flex "+
                                                      (isPhone(screenSize.width) ? ' flex-col text-left py-1 ' : ' space-x-2 ')
                                                    }
                                                  >
                                                    <div className="w-32 text-left">Uang pangkal</div>
                                                    {!isPhone(screenSize.width) && (<div>:</div>)}
                                                    <div>
                                                      {
                                                        p.jenisHargaUangPangkal === 'harga_eksak' ?
                                                          (<label>
                                                            <span className={p.uangPangkalPromo ? 'line-through' : ''}>{formatRupiah(p.uangPangkal)}</span> {p.uangPangkalPromo && (<span>{formatRupiah(p.uangPangkalPromo)}</span>)}
                                                            </label>) 
                                                          :
                                                          (<label>{formatRupiah(p.uangPangkalRentangDari)} - {formatRupiah(p.uangPangkalRentangHingga)} </label>)
                                                      }
                                                    </div>
                                                  </div>
                                                </div>
                                                <div
                                                  className=""
                                                  style={{
                                                    fontSize: '13px'
                                                  }}
                                                >
                                                  <div 
                                                    className={
                                                      "flex "+
                                                      (isPhone(screenSize.width) ? ' flex-col text-left py-1 ' : ' space-x-2 ')
                                                    }
                                                  >
                                                    <div className="w-32 text-left">Sekolah</div>
                                                    {!isPhone(screenSize.width) && (<div>:</div>)}
                                                    <div>{p.namaSekolah}</div>
                                                  </div>
                                                  <div 
                                                    className={
                                                      "flex "+
                                                      (isPhone(screenSize.width) ? ' flex-col text-left py-1 ' : ' space-x-2 ')
                                                    }
                                                  >
                                                    <div className="w-32 text-left">No. Telp</div>
                                                    {!isPhone(screenSize.width) && (<div>:</div>)}
                                                    <div>{p.phone}</div>
                                                  </div>
                                                </div>
                                                </>
                                              )}
        
                                            </div>
                                          </button>
                                        ))
                                }
                              </div>
                            </div>
                            <div
                              className="space-y-1"
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: '14px'
                                }}
                              >
                                <div>
                                  Informasi PMB*
                                </div>
                                <div
                                  className="italic text-gray-500"
                                  style={{ fontSize: '12px' }}
                                >
                                  darimana anda mendapatkan informasi PMB kami?
                                </div>
                              </div>
                              <div
                                className="relative"
                              >
                                <Select
                                  value={infoOpts.selectedOpt}
                                  options={infoOpts.data}
                                  menuPlacement="auto"
                                  className="w-full border border-gray-200 rounded-md outline-green-500"
                                  placeholder="Pilih salah satu"
                                  onChange={(value) => {
                                    setInfoOpts({ ...infoOpts, selectedOpt: value })
                                  }}
                                />
                              </div>
                            </div>
                            <div>
                              <button
                                className={
                                  form.fullName == '' ||
                                  form.email == '' ||
                                  form.noHp == '' ||
                                  form.password == '' ||
                                  jenjangOpts.selectedJenjang == null ||
                                  jenisPembiayaan.selectedJenis == null ||
                                  selectedProgram == null ?
                                  "w-full py-2 flex justify-center bg-gray-300 hover:bg-gray-300 text-black rounded-md"
                                  :
                                  "w-full py-2 flex justify-center bg-green-800 hover:bg-green-700 text-white rounded-md"
                                }
                                style={{
                                  fontSize: '14px'
                                }}
                                onClick={onRegister}
                                disabled={
                                  form.fullName == '' ||
                                  form.email == '' ||
                                  form.noHp == '' ||
                                  form.password == '' ||
                                  jenjangOpts.selectedJenjang == null ||
                                  jenisPembiayaan.selectedJenis == null ||
                                  selectedProgram == null
                                }
                              >
                                {
                                  isProcessing ?
                                    <RiLoader5Fill className="h-5 w-5 animate-spin"/>
                                    :
                                    'Daftar'
                                }
                              </button>
                            </div>
                          </div>

                        </div>
                      </div>
                      
                      <div
                        className="py-5 text-center border-t"
                        style={{
                          fontSize: '14px'
                        }}
                      >
                        <label>Sudah memiliki akun? Silahkan </label>
                        <Link to="/login"><span className="text-green-500 font-bold">masuk</span></Link>
                      </div>
                    </div>
                  </>
                )
            }


          </div>

        </div>


      </div>

    </div>
  )

}

export default RegistrationPage;